<section class="proof-wrap">
  <div class="wrap-lg">
    <div class="proof-inner">
      <div class="nav-sec">
        <div class="back-nav">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name" (click)="goToHome()">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">{{ proofTab=='bank' ?  (isMultiBank? ('Confirm'+' ' +bankDetailsText+' '+ 'Bank Account'):( bankDetailsText+ ' '+'Bank Details')) : proofTab=='aadhar' ? 'Aadhaar Details' : proofTab=='selfie' ? 'Take Applicant’s Selfie' : 'Details' }}</div>
          <div class="page-info">{{ isMultiBank? '': getInfo(proofTab) }}</div>
        </div>
      </div>
      <div class="box-tab">
        <div class="tab-sec">
          <div class="primary-tab">
            <!-- <div class="tab-item" [class.active]="proofTab == 'bank'" >Bank <span class="mob-hide">Details</span></div> -->
            <!-- <div class="tab-item" [class.active]="proofTab == 'aadhar'" >Aadhaar <span class="mob-hide">Details</span></div> -->
            <!-- <div class="tab-item" [class.active]="proofTab == 'selfie'" >Selfie</div> -->
          </div>
        </div>
        <div class="tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</section>

